module.exports = __webpack_public_path__ + "static/media/bronze.90a6d880.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/cattributes/bronze.svg
// module id = 167
// module chunks = 0